import { useMemo } from "react";
import { useBookingInfo } from "./useBookingInfo";
import secondaryComponents from "../../..";
import styles from "../OrderItems/styles.module.scss";

export const BookingInfo = ({ orderItems = [] }) => {
  const formatBookingData = (orderItems = []) => {
    const bookingsMap = {};

    orderItems.forEach((item) => {
      const booking = item?.booking_data;
      const duration = item?.booking_data?.duration || 0;

      if (!booking?.date || !booking?.start_time) return;

      if (!bookingsMap[booking.date]) {
        bookingsMap[booking?.date] = [];
      }

      bookingsMap[booking.date].push({
        start_time: booking?.start_time,
        duration,
      });
    });

    return Object.entries(bookingsMap)?.map(([date, bookings]) => ({
      date,
      bookings: bookings.sort((a, b) =>
        a?.start_time?.localeCompare(b?.start_time),
      ),
    }));
  };

  const bookings = useMemo(() => {
    return formatBookingData(orderItems);
  }, [orderItems]);

  const { instance } = useBookingInfo({ bookings });
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      {bookings?.length === 0 ? null : (
        <div>
          <h5>Booking Informations</h5>

          <div className={styles.orderItem}>
            <secondaryComponents.TableHelper
              getTableProps={getTableProps}
              getTableBodyProps={getTableBodyProps}
              headerGroups={headerGroups}
              rows={rows}
              prepareRow={prepareRow}
              minHeight={0}
            >
              <div className="text-center mt-5 mb-5">
                <h4 className="font-weight-semibold text-center mt-4">
                  No Data Available
                </h4>
              </div>
            </secondaryComponents.TableHelper>
          </div>
        </div>
      )}
    </>
  );
};
